import{gql as e}from"@apollo/client";const s=e`
  mutation deleteUserGeneratedResponse($questionResponseId: Int!, $questionResponseSetId: Int!) {
    questionSet {
      removeAvailableAnswer(responseId: $questionResponseId, responseSetId: $questionResponseSetId)
    }
  }
`;export{s as DELETE_USER_GENERATED_RESPONSE_MUTATION};
//# sourceMappingURL=useDeleteUserGeneratedResponse.graphql.js.map
